import React, { useState } from 'react';
import axios from 'axios';
import { Eye, EyeOff, Loader2, LogIn } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const errText = (d) => (typeof d === 'string' ? d : Array.isArray(d) ? d.map(e => e?.msg || JSON.stringify(e)).join(' ') : d?.msg || 'Sign-in failed');

export default function PasswordLogin({ onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await axios.post(`${API}/auth/password/login`, { email: email.trim(), password }, { withCredentials: true });
      if (res.data?.session_token && typeof window !== 'undefined') window.__FR_SESSION_TOKEN__ = res.data.session_token;
      onSuccess?.(res.data);
    } catch (err) {
      setError(errText(err?.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="password-login-form">
      <Input type="email" autoComplete="username" placeholder="Work email" value={email} onChange={e => setEmail(e.target.value)} required className="h-11" data-testid="password-login-email" />
      <div className="relative">
        <Input type={show ? 'text' : 'password'} autoComplete="current-password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required className="h-11 pr-10" data-testid="password-login-password" />
        <button type="button" onClick={() => setShow(s => !s)} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600" aria-label={show ? 'Hide password' : 'Show password'} data-testid="password-login-toggle-visibility">
          {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
        </button>
      </div>
      {error && <p className="text-xs text-rose-600" data-testid="password-login-error">{error}</p>}
      <Button type="submit" disabled={busy || !email || !password} className="w-full h-11 bg-[#0A1128] text-white hover:bg-slate-800 rounded-lg text-sm font-medium flex items-center justify-center gap-2" data-testid="password-login-submit">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />} Sign in
      </Button>
      <p className="text-[11px] text-slate-400 text-center">No password yet? Sign in with Google once, then set one from your profile menu.</p>
    </form>
  );
}
